import React from "react"

import { TResolvedTextMedia } from "@/lib/kontent/components/getTextMedia"

import { Card } from "./Card"

type TCardResolverProps = {
  resolvedData: TResolvedTextMedia
  clamp?: boolean
  isInArticle: boolean
}

const CardResolver = ({
  resolvedData,
  isInArticle,
  clamp = false,
}: TCardResolverProps) => {
  const kontentData = {
    title: resolvedData.title,
    isInArticle: isInArticle,
    body: resolvedData.text,
    src: resolvedData.image
      ? resolvedData.image.url + "?h=3000&w=3000&fm=webp&q=80"
      : undefined,
    alt: resolvedData.image?.description,
    clamp: clamp,
    tagLabel: resolvedData.tag,
    small: false,
    variant:
      resolvedData.textBackground === "Light"
        ? ("neutral" as const)
        : ("primary" as const),
  }

  return <Card {...kontentData} />
}

export { CardResolver, type TCardResolverProps }
